import _default, { getServerSideProps as _ } from "../../src/pages/ChapterList";
export const getServerSideProps = _;

export default _default;
